import { render, staticRenderFns } from "./LayoutSidebarItem.vue?vue&type=template&id=33f80bec&"
import script from "./LayoutSidebarItem.vue?vue&type=script&lang=js&"
export * from "./LayoutSidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSidebarItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports